import { NgModule } from '@angular/core';

import { MedisSidebarComponent } from './sidebar.component';

@NgModule({
  declarations: [MedisSidebarComponent],
  exports: [MedisSidebarComponent],
})
export class MedisSidebarModule {}
